import styled from "styled-components";
import { CartGroupContainer } from "@cart-ui/components/cart-group";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

export const Container = styled(CartGroupContainer)(({ theme }) => ({
    paddingBottom: `${theme.spacing.small} !important`,
    marginBottom: `${theme.spacing.large}  !important`,
}));

export const ContainerV2 = styled(CartGroupContainer)(({ theme }) => ({
    marginBottom: `${theme.spacing.large}  !important`,
}));

export const FadedSaperator = styled.div(({ theme }) => ({
    borderRadius: theme.cornerRadius.large,
    height: "1px",
    background: "linear-gradient(90deg, #D9DADB -43.58%, rgba(217, 218, 219, 0.00) 98.39%)",
    marginTop: theme.spacing.xSmall,
    marginBottom: theme.spacing.xxSmall,
}));

export const EditRow = styled.div<{ isV2?: boolean }>(({ theme, isV2 }) => ({
    paddingTop: isV2 ? theme.spacing.medium : 0,
    display: "flex",
    alignItems: isV2 ? "start" : "center",
}));

export const EditContainer = styled.div(({ theme }) => ({
    marginTop: theme.spacing.xxSmall,
    display: "flex",
    flexDirection: "column",
}));

interface ITextContainerStyle {
    removeBottomBorder?: boolean;
    isV2?: boolean;
}
export const HeaderTextContainer = styled.div(({ theme }) => ({
    margin: `0 ${theme.spacing.xSmall}`,
}));

export const TextContainer = styled.div<ITextContainerStyle>(
    ({ theme, isV2 }) => ({
        borderBottom: isV2 ? undefined : `1px dashed ${theme.colors.light.background_Button_Disabled}`,
        display: "flex",
        paddingTop: theme.spacing.medium,
        paddingBottom: isV2 ? 0 : theme.spacing.medium,
        margin: `0 ${theme.spacing.xSmall}`,
        width: "100%",
        ...(isV2 && {
            justifyContent: "space-between",
            paddingTop: 0,
        }),
    }),
    ({ removeBottomBorder }) =>
        removeBottomBorder && {
            borderBottom: 0,
        },
);

export const EditCta = styled(Text)(({ theme }) => ({
    paddingLeft: theme.spacing.xSmall,
}));

export const TextLabel = styled(Text)<{ isV2?: boolean }>(({ theme, isV2 }) => ({
    borderRight: isV2 ? undefined : `${theme.spacing.xxxSmall} solid ${theme.colors.light.border_Secondary}`,
    paddingRight: theme.spacing.xSmall,
}));

export const StyledSeparator = styled.div(({ theme }) => ({
    margin: `${theme.spacing.medium} calc(${theme.spacing.medium} * -1) 0`,
}));
